import React from "react";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { sanitizeHtml } from "../../../utils/sanitizeHtml";

export const tableConstants = (permissions, deleteHandler, showModel, currentPage, pageSize) => {
  let count = 1;
  let formatedData = [
    {
      title: 'SNo',
      render: () => {
        return <span>{(currentPage) * pageSize + count++}</span>;
      },
    },
    {
      title: 'Title',
      render: rowData => {
        return <span>{rowData.title}</span>;
      },
    },
    {
      title: 'Is_Holiday',
      render: rowData => {
        return <span>{rowData.is_holiday === "1" ? "YES" : "NO"}</span>;
      },
    },
    {
      title: 'Event_Date',
      render: rowData => {
        return <span>{rowData.event_date}</span>;
      },
    },
    {
      title: 'Description',
      render: rowData => {
        // eslint-disable-next-line react/no-danger -- sanitized via DOMPurify in sanitizeHtml() above
        return <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(rowData.description) }} />;
      },
    },
    {
      title: 'Action',
      render: rowData => {
        return <span>
          {permissions.includes("event.calendar.update") && (
            <FontAwesomeIcon
              icon={faEdit}
              style={{
                color: "var(--color-primary-text)",
                marginRight: "10px",
                cursor: "pointer"
              }}
              onClick={() => showModel(rowData)}
            />)}
          {permissions.includes("event.calendar.delete") &&
            <FontAwesomeIcon
              icon={faTrashAlt}
              style={{
                color: "var(--color-danger-text)",
                marginRight: "10px",
                cursor: "pointer"
              }}
              onClick={() => {
                if (
                  window.confirm(
                    "Are you sure you wish to delete this item?"
                  )
                ) {
                  deleteHandler(rowData);
                }
              }}
            />
          }
        </span>;
      },
    },
  ];
  return formatedData;
};
